import { IApplicationState } from '../../types/redux';

export function selectRegionId(state: IApplicationState) {
  return state.geo.regionId;
}
